import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { applyHtmlAttrs } from './i18n';
import 'sweetalert2/dist/sweetalert2.min.css';
import './styles.css';

applyHtmlAttrs();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
